export type Language = 'en' | 'hi';

export const translations = {
  en: {
    deptName: 'District School Education Department, Nuh, Haryana',
    deptNameSub: 'Government of Haryana • शिक्षा विभाग हरियाणा',
    appName: 'Board Exam Ki Taiyari & Improvement',
    appTagline: 'School-level Student Assessment, Marks, Attendance & Performance Analytics Portal',
    
    // Auth & Common
    login: 'Sign In / लॉगिन',
    username: 'Username / Mobile',
    password: 'Password',
    loginButton: 'Access Portal',
    logout: 'Logout',
    role: 'Role',
    admin: 'Principal / Admin',
    teacher: 'Subject Teacher',
    active: 'Active',
    inactive: 'Inactive',
    status: 'Status',
    actions: 'Actions',
    save: 'Save Changes',
    saving: 'Saving...',
    cancel: 'Cancel',
    edit: 'Edit',
    view: 'View Details',
    deactivate: 'Deactivate',
    activate: 'Activate',
    search: 'Search...',
    filter: 'Filter',
    reset: 'Reset',
    close: 'Close',
    back: 'Back',
    all: 'All',
    loading: 'Loading data...',
    noData: 'No records found.',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    confirm: 'Confirm Action',

    // Nav
    nav_dashboard: 'Dashboard',
    nav_school_profile: 'School Profile',
    nav_principal_profile: 'Principal Profile',
    nav_teachers: 'Teachers Management',
    nav_board_class: 'Board & Class Setup',
    nav_academic_sessions: 'Academic Sessions',
    nav_students: 'Students Management',
    nav_marks_entry: 'Marks Entry',
    nav_assessment: 'Assessment Tests',
    nav_sat: 'SAT Examinations',
    nav_attendance: 'Attendance',
    nav_analysis: 'Performance Analysis',
    nav_reports: 'Reports & Export',
    nav_google_sheets: 'Google Sheets Sync',
    nav_settings: 'System Settings',
    nav_audit_logs: 'Audit Logs',
    nav_my_profile: 'My Profile',
    nav_my_classes: 'My Assigned Classes',

    // Dashboard Cards
    totalTeachers: 'Total Active Teachers',
    totalStudents: 'Total Students',
    hbseStudents: 'HBSE Students',
    cbseStudents: 'CBSE Students',
    class10Students: 'Class 10 Students',
    class12Students: 'Class 12 Students',
    activeSession: 'Active Academic Session',
    schoolInfo: 'School Information',
    principalName: 'Principal Name',
    schoolCode: 'School Code',
    district: 'District',
    state: 'State',
    quickActions: 'Quick Navigation & Phase Overview',

    // Teacher Management
    addTeacher: 'Add New Teacher',
    editTeacher: 'Edit Teacher',
    teacherName: 'Teacher Name',
    mobile: 'Mobile Number',
    email: 'Email Address',
    designation: 'Designation',
    subject: 'Subject',
    board: 'Board',
    class: 'Class',
    section: 'Section',
    assignedClasses: 'Assigned Classes & Subjects',
    addAssignment: 'Add Class/Subject Assignment',
    removeAssignment: 'Remove',
    deactivateConfirmTitle: 'Confirm Teacher Deactivation',
    deactivateConfirmMsg: 'Are you sure you want to deactivate this teacher? They will not be able to log in, but their historical data will remain preserved.',
    activateConfirmTitle: 'Confirm Teacher Activation',
    activateConfirmMsg: 'Are you sure you want to reactivate this teacher account?',

    // School Profile
    schoolName: 'School Name',
    schoolAddress: 'Complete Address',
    officialEmail: 'Official Email',
    principalMobile: 'Principal Mobile',

    // Academic Sessions
    createSession: 'Add Academic Session',
    sessionName: 'Session Name (e.g. 2026-2027)',
    startDate: 'Start Date',
    endDate: 'End Date',
    setActiveSession: 'Set as Active Session',
    activeSessionWarning: 'Only one session can be active at a time. All new marks and attendance entries will default to this session.',

    // Board & Subject Setup
    boardsList: 'Registered Educational Boards',
    classesList: 'Configured Classes',
    subjectsList: 'Subjects Master Catalog',
    classSubjectsMapping: 'Class-wise Subject Structure',
    addSubject: 'Add Subject',
    addClass: 'Add Class',
    assignSubjectToClass: 'Map Subject to Class',

    // Phase 1 notices
    phase1NoticeTitle: 'Phase 1 Foundation Active',
    phase1NoticeBody: 'School configuration, authentication, role-based navigation, teacher management and database foundation are fully operational. Student marks, attendance, SAT, analytics, and reports are scheduled for subsequent phases.'
  },
  hi: {
    deptName: 'ज़िला विद्यालय शिक्षा विभाग, नूँह, हरियाणा',
    deptNameSub: 'हरियाणा सरकार • Department of School Education, Haryana',
    appName: 'बोर्ड परीक्षा की तैयारी एवं सुधार',
    appTagline: 'विद्यालय-स्तरीय छात्र मूल्यांकन, अंक, उपस्थिति एवं प्रदर्शन विश्लेषण पोर्टल',

    // Auth & Common
    login: 'लॉगिन करें',
    username: 'उपयोगकर्ता नाम / मोबाइल',
    password: 'पासवर्ड',
    loginButton: 'पोर्टल में प्रवेश करें',
    logout: 'लॉगआउट',
    role: 'भूमिका',
    admin: 'प्रधानाचार्य / एडमिन',
    teacher: 'विषय शिक्षक',
    active: 'सक्रिय',
    inactive: 'निष्क्रिय',
    status: 'स्थिति',
    actions: 'कार्य',
    save: 'बदलाव सहेजें',
    saving: 'सहेजा जा रहा है...',
    cancel: 'रद्द करें',
    edit: 'संपादित करें',
    view: 'विवरण देखें',
    deactivate: 'निष्क्रिय करें',
    activate: 'सक्रिय करें',
    search: 'खोजें...',
    filter: 'फ़िल्टर',
    reset: 'रीसेट',
    close: 'बंद करें',
    back: 'वापस',
    all: 'सभी',
    loading: 'डेटा लोड हो रहा है...',
    noData: 'कोई रिकॉर्ड नहीं मिला।',
    success: 'सफलता',
    error: 'त्रुटि',
    warning: 'चेतावनी',
    confirm: 'पुष्टि करें',

    // Nav
    nav_dashboard: 'डैशबोर्ड',
    nav_school_profile: 'विद्यालय प्रोफ़ाइल',
    nav_principal_profile: 'प्रधानाचार्य प्रोफ़ाइल',
    nav_teachers: 'शिक्षक प्रबंधन',
    nav_board_class: 'बोर्ड एवं कक्षा सेटअप',
    nav_academic_sessions: 'शैक्षणिक सत्र',
    nav_students: 'छात्र प्रबंधन',
    nav_marks_entry: 'अंक प्रविष्टि',
    nav_assessment: 'आकलन परीक्षाएं',
    nav_sat: 'SAT परीक्षाएं',
    nav_attendance: 'उपस्थिति',
    nav_analysis: 'प्रदर्शन विश्लेषण',
    nav_reports: 'रिपोर्ट एवं निर्यात',
    nav_google_sheets: 'गूगल शीट्स सिंक',
    nav_settings: 'सिस्टम सेटिंग्स',
    nav_audit_logs: 'ऑडिट लॉग',
    nav_my_profile: 'मेरी प्रोफ़ाइल',
    nav_my_classes: 'मेरी कक्षाएं एवं विषय',

    // Dashboard Cards
    totalTeachers: 'कुल सक्रिय शिक्षक',
    totalStudents: 'कुल विद्यार्थी',
    hbseStudents: 'HBSE विद्यार्थी',
    cbseStudents: 'CBSE विद्यार्थी',
    class10Students: 'कक्षा 10 विद्यार्थी',
    class12Students: 'कक्षा 12 विद्यार्थी',
    activeSession: 'सक्रिय शैक्षणिक सत्र',
    schoolInfo: 'विद्यालय विवरण',
    principalName: 'प्रधानाचार्य का नाम',
    schoolCode: 'विद्यालय कोड',
    district: 'ज़िला',
    state: 'राज्य',
    quickActions: 'त्वरित नेविगेशन एवं चरण अवलोकन',

    // Teacher Management
    addTeacher: 'नया शिक्षक जोड़ें',
    editTeacher: 'शिक्षक विवरण संपादित करें',
    teacherName: 'शिक्षक का नाम',
    mobile: 'मोबाइल नंबर',
    email: 'ईमेल पता',
    designation: 'पदनाम',
    subject: 'विषय',
    board: 'बोर्ड',
    class: 'कक्षा',
    section: 'वर्ग (Section)',
    assignedClasses: 'आवंटित कक्षाएं एवं विषय',
    addAssignment: 'कक्षा/विषय आवंटन जोड़ें',
    removeAssignment: 'हटाएं',
    deactivateConfirmTitle: 'शिक्षक निष्क्रिय करने की पुष्टि',
    deactivateConfirmMsg: 'क्या आप वाकई इस शिक्षक को निष्क्रिय करना चाहते हैं? वे लॉगिन नहीं कर सकेंगे, परंतु उनका पूर्व डेटा सुरक्षित रहेगा।',
    activateConfirmTitle: 'शिक्षक सक्रिय करने की पुष्टि',
    activateConfirmMsg: 'क्या आप इस शिक्षक खाते को पुनः सक्रिय करना चाहते हैं?',

    // School Profile
    schoolName: 'विद्यालय का नाम',
    schoolAddress: 'पूर्ण पता',
    officialEmail: 'आधिकारिक ईमेल',
    principalMobile: 'प्रधानाचार्य मोबाइल',

    // Academic Sessions
    createSession: 'नया शैक्षणिक सत्र जोड़ें',
    sessionName: 'सत्र नाम (उदा. 2026-2027)',
    startDate: 'प्रारंभ तिथि',
    endDate: 'समाप्ति तिथि',
    setActiveSession: 'सक्रिय सत्र के रूप में सेट करें',
    activeSessionWarning: 'एक समय में केवल एक सत्र सक्रिय हो सकता है। सभी नई प्रविष्टियां इसी सत्र में होंगी।',

    // Board & Subject Setup
    boardsList: 'पंजीकृत शिक्षा बोर्ड',
    classesList: 'कॉन्फ़िगर की गई कक्षाएं',
    subjectsList: 'विषय मास्टर सूची',
    classSubjectsMapping: 'कक्षा-वार विषय संरचना',
    addSubject: 'नया विषय जोड़ें',
    addClass: 'नई कक्षा जोड़ें',
    assignSubjectToClass: 'कक्षा में विषय जोड़ें',

    // Phase 1 notices
    phase1NoticeTitle: 'चरण 1 आधारभूत संरचना सक्रिय',
    phase1NoticeBody: 'विद्यालय कॉन्फ़िगरेशन, प्रमाणीकरण, भूमिका-आधारित नेविगेशन, शिक्षक प्रबंधन और डेटाबेस आधार पूरी तरह से चालू हैं। छात्र अंक, उपस्थिति, SAT और रिपोर्ट अगले चरणों में जोड़े जाएंगे।'
  }
};
